import { FC } from 'react';
import { CbButton, CbButtonProps } from '../CbButton';
export interface RequestStatus {
  idle: boolean;
  pending: boolean;
  success: boolean;
  failed: boolean;
}
export interface CbSubmitButtonProps extends CbButtonProps {
  status: RequestStatus;
}
export const CbSubmitButton: FC<CbSubmitButtonProps> = ({
  children,
  status,
  ...props
}) => {
  const content = children;
  const isDisabled = status?.pending || status?.success;
  return <CbButton type="submit" disabled={props?.isDisabled || isDisabled} isLoading={status.pending} loadingText="Pending..." {...props} data-sentry-element="CbButton" data-sentry-component="CbSubmitButton" data-sentry-source-file="CbSubmitButton.tsx">
      {content}
    </CbButton>;
};